import { Table } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import { IQuoteHistory } from 'partsOld/types';

import { columns, defaultColumnStyle } from './columns';

interface IProps {
  records: IQuoteHistory[];
  isLoading: boolean;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  fetchNextPage;
}

const HistoryListView = ({
  records,
  isFetchingNextPage,
  isLoading,
  hasNextPage,
  fetchNextPage,
}: IProps) => {
  return (
    <Table
      columns={columns}
      data={records}
      name={TableNames.UOMS_LIST}
      alternating={false}
      headerLines={2}
      borderBottom={true}
      defaultColumnStyle={defaultColumnStyle}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
    />
  );
};

export default HistoryListView;
